// extracted by mini-css-extract-plugin
export default {"container":"ScrollToTop_container__b2doU","scrollIcon":"ScrollToTop_scrollIcon__Aieod"};